// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sendsmsLabels {
  padding-bottom: 20px;
}

.description-text {
  resize: none;
  border: none Transparent;
  outline: none;
  height: 100px;
  color: #2C2B2D;
  font-family: Inter;
  font-style: normal;
  font-size: 13px;
  width: 100%;
}

.label-width {
  width: 105px;
}

.externalComm-div-padding {
  padding-left: 17px;
  padding-right: 15px;
}

.check-box-margin {
  margin-left: -7px;
}

.agree-to-checkbox-margin {
  margin-left: 8px;
  z-index: 90000;
}

.info-label {
  font-weight: bold;
  padding-right: 15px;
}

.sendSmsForm {
  max-width: 99.5%;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
